(() => {
  if (window.vxCollectionFiltersReady) return;
  window.vxCollectionFiltersReady = true;
  const rootSelector = '[data-vx-collection-controls]';
  const navigate = (url) => {
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  };

  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!control.closest(rootSelector)) return;
    const url = new URL(window.location.href);
    if (control.matches('[data-vx-sort]')) {
      url.searchParams.set('sort_by', control.value);
    } else if (control.matches('[data-vx-filter]')) {
      const values = url.searchParams.getAll(control.name).filter((value) => value !== control.value);
      if (control.checked) values.push(control.value);
      url.searchParams.delete(control.name);
      values.forEach((value) => url.searchParams.append(control.name, value));
    } else {
      return;
    }
    navigate(url);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-vx-price-form]') || !form.closest(rootSelector)) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    form.querySelectorAll('[data-vx-price]').forEach((input) => {
      url.searchParams.delete(input.name);
      if (input.value.trim() !== '') url.searchParams.set(input.name, input.value);
    });
    navigate(url);
  });

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-vx-filter-remove]');
    if (!link || !link.closest(rootSelector)) return;
    event.preventDefault();
    const url = new URL(link.href, window.location.href);
    const sort = new URL(window.location.href).searchParams.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);
    navigate(url);
  });
})();
